// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/overlay/index.css
// module id = 49
// module chunks = 1 2 3 4 5